import { Rate } from 'antd';
import * as S from './styled';
import { useTranslation } from 'react-i18next';
import { LIST_RATE } from '../../configs/common';

export function RateBox() {
  const { t } = useTranslation();

  return (
    <S.RateStyled>
      <S.RateTitleStyled>{t('rate_box.text_1')}</S.RateTitleStyled>

      <S.RateListStyled>
        {LIST_RATE.map((item, index) => (
          <S.RateItemStyled key={index}>
            <div className="avatar">
              <img src={item.avatar_url} alt={item.avatar_url} />
            </div>
            <div className="comment">
              <div className="comment-name">{item.user_name}</div>
              <div className="comment-rate">
                <Rate value={item.start} />
              </div>
              <div className="comment-message">{item.message}</div>
            </div>
          </S.RateItemStyled>
        ))}
      </S.RateListStyled>
    </S.RateStyled>
  );
}
